import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { actions as reduxActions } from '../reducers';
import { actions as sagaActions, GET_CONNECTIONS } from './types';
import { actions as loaderReduxActions } from '../../../partials/loader/reducers';
import { getData } from '../../../utils/http';
import { URLS } from '../../../consts/endpoints';
import { isArray } from '../../../utils/isDefined';
import mapConnections from './mapConnections';
import createProductOptions from '../../../utils/createProductOptions';

export function getConnections({ clientId }) {
  return {
    type: sagaActions[GET_CONNECTIONS],
    clientId
  };
}

export function* fetchConnections({ clientId }) {
  yield put(loaderReduxActions.startSpinLoader());

  let connections = [];
  let productOptions = [];

  try {
    const data = yield call(
      getData,
      `${URLS.QUOTE_CLIENTS_V2}/${clientId}/connections`
    );

    if (isArray(data)) {
      connections = yield call(mapConnections, data);

      productOptions = yield call(createProductOptions, connections);
    }
  } catch {}

  yield put(reduxActions.setConnections({ connections, productOptions }));
  yield put(loaderReduxActions.stopSpinLoader());
}

function* watchGetConnections() {
  yield takeLatest(sagaActions[GET_CONNECTIONS], fetchConnections);
}

export default watchGetConnections();
